$(document).ready(function () {
	$('.knowledge-hub').each(function () {
		var $section = $(this);

		new Swiper($section.find('.knowledge-hub__slider')[0], {
			slidesPerView: 1,
			spaceBetween: 40,
			speed: 700,
			autoHeight: true,
			pagination: {
				el: $section.find('.knowledge-hub__pagination')[0],
				clickable: true,
			},
		});
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/knowledge-hub.js